module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body prest-upload-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex start-between"
  }, [_vm._m(0), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        followCursor: true,
        theme: 'light'
      }),
      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5> Baixar Todos os Anexos Complementares </h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIPComplementar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.editando) ? _c('b-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.toggleCadastro(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Novo Registro")]) : _vm._e(), _vm._v(" "), (!_vm.editando) ? _c('div', {
    staticClass: "column all-start prest-complementar-container"
  }, [_c('b-container', {
    staticClass: "prest-table",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-centered prest-button-row"
        }, [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "title": '<h5> Baixar Documento </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.downloadAnexo(row.item.documento)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "error",
            "size": "button--size-ss",
            "title": "'<h5> Excluir Documento </h5>'"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.apagarAnexoComplementar(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)]
      }
    }, {
      key: "documento.ds_nome_arquivo",
      fn: function(row) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.downloadAnexo(row.item.documento)
            }
          }
        }, [_vm._v(_vm._s(row.item.documento.ds_nome_arquivo))])]
      }
    }, {
      key: "documento.dt_criado",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.documento.dt_criado, "L")))])]
      }
    }], null, false, 3098741170)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editando) ? _c('div', {
    staticClass: "column start-centered prest-complementar-upload-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-complementar-upload-form"
  }, [_c('label', {
    staticClass: "f-required",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.observacoes),
      expression: "observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "observacao",
      "placeholder": "Motivo da inclusão do documento complementar",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.observacoes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "prest-table"
  }, [_c('uploadDocumentosPhpPrestacao', {
    attrs: {
      "propDocumentos": _vm.anexo,
      "documentTypes": '',
      "local-uso": 'SOLICITACAO_PAGAMENTO',
      "disableAdd": _vm.anexo.length > 0,
      "restricaoArquivo": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('b-button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.salvarAnexo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.editando = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar")])], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Documentos Complementares "), _c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastrando novo Registro")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55cf7c3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/AnexosComplementares.vue
// module id = 1904
// module chunks = 2